<div class="d-flex flex-column">
  @if (label) {
    <div class="label" [ngClass]="{ 'text-danger': isError }">
      {{ label }}
      @if (isRequired) {
        <span>*</span>
      }
    </div>
  }
  <input
    #googleAddressSearch
    matInput
    name="inputTxt"
    class="input-default w-100"
    [placeholder]="placeholder"
    type="text"
    autocomplete="off"
    [ngClass]="{ 'disabled-input': isDisabled, 'error-input': isError }"
    [(ngModel)]="input"
    [disabled]="isDisabled"
    (ngModelChange)="onchange($event)"
    (focusout)="focusOutInput($event)"
  />
</div>
